import { TextMessage } from './TextMessage'
import { ChatMessage, MessageTypeEnum } from 'types/chat-message'

export type BotMessageProps = {
  messageItem: ChatMessage
  startsSequence: boolean
  endsSequence: boolean
  index: number
}

export const BotMessage = ({ messageItem, startsSequence, endsSequence }: BotMessageProps) => {
  const botResponse = []
  let showBotAvatar = true

  // console.debug({ endsSequence })

  if (endsSequence) {
    showBotAvatar = true
  }
  if (messageItem.type === MessageTypeEnum.TEXT) {
    botResponse.push(
      <TextMessage
        startsSequence={startsSequence}
        endsSequence={endsSequence}
        showBotAvatar={showBotAvatar}
        text={messageItem.message}
        key={`${messageItem._id}_text`}
        messageItem={messageItem}
      />,
    )
  }
  // if (messageItem?.type === 'role_buttons') {
  //   botResponse.push(
  //     <MessageButtons
  //       key={`${index}_buttons`}
  //       enabled={isLastMessage}
  //       buttons={[
  //         <ChatRoleButton key={ChatRole.expositor} enabled={isLastMessage} role={ChatRole.expositor} />,
  //         <ChatRoleButton key={ChatRole.visitor} enabled={isLastMessage} role={ChatRole.visitor} />,
  //       ]}
  //     />,
  //   )
  // }
  return <>{botResponse}</>
}
